import React from 'react';
import {Link} from '@reach/router';
import {compose, graphql} from 'react-apollo';

import {Loading, Card} from 'ui-kit';
import {ALL_PLANS} from '../../graphql';

import {PlansList} from './components';

export function AllPlans({data}) {
  if (data == null || data.error != null) {
    return (
      <Card>
        <p>An error occurred. Try refreshing this page or come back later.</p>
      </Card>
    );
  }

  if (data.loading) {
    return (
      <Card>
        <Loading />
      </Card>
    );
  }

  const {
    me: {practice},
  } = data;
  const {
    membershipPlans: {edges: membershipPlans},
  } = practice;

  if (membershipPlans.length === 0) {
    return (
      <Card>
        <p>
          You don't have any plans yet. <Link to="/plans/new">Create one</Link>.
        </p>
      </Card>
    );
  }

  return (
    <Card noSpacing>
      <PlansList plans={membershipPlans} />
    </Card>
  );
}

export default compose(
  graphql(ALL_PLANS, {options: {fetchPolicy: 'network-only'}}),
)(AllPlans);
